<header>
  <div class="header-main">
    <div class="header-logo">
      <img src="../../../assets/images/renterz-logo.svg" alt="Renterz Logo" class="company-icon">
    </div>
    <!-- <div class="header-location">
    <div class="header-location-title">
      <img src="../../../assets/images/location-pin.svg" alt="location-icon" class="icon-location-pin">
      <span class="user-address-type">HOME</span>
    </div>
    <div class="user-location-container">
      <span>
        Nagar road, kalyani nagar, pune...
      </span>
      <img src="../../../assets/images/header-location-down-arrow.svg" alt="location selection arrow">
    </div>
  </div> -->
  </div>

  <div class="header-signup">
    <!-- <span class="text-not-account">Don't have an account?</span> -->
    <!-- <button type="button" class="button-back" (click)="logout()"><img src="../../../assets/images/orange-arrow.svg"
  alt="orange colored arrow"
style="margin-right: 5px;" /> Back to main website</button> -->

    @if (isMobile) {
    <!-- Mobile Hamburger Menu -->
    <button class="hamburger-menu" (click)="toggleSidebar()">
      <span></span>
      <span></span>
      <span></span>
    </button>
    } @else {
    <!-- Desktop Menu -->
    @if (isLoggedIn) {
    <div class="mr-2">
      <button class="button-back" (click)="navigateFaqs()" [title]="translationService.instant('header.faqs', 'FAQs')">
        <img class="mr-1 mb-1" src="../../../assets/icons/faqs.svg" alt="faqs-icon" />
        <span>FAQs</span>
      </button>
    </div>

    <div class="custom-dropdown">
      <button class="button-back" (click)="toggleDropdown()">
        <img src="../../../assets/icons/sidebar/profile_active.svg" alt="user-icon" />
        {{ userName }}
      </button>
      <ul class="dropdown-menu" [ngClass]="{'dropdown-below': isOpen}">
        @for (option of dropdownOptions; track option) {
        <li (click)="selectOption(option.value)">
          <i [class]="option.value"></i>
          <span>{{ option.label }}</span>
        </li>
        }
      </ul>
    </div>
    }

    <!-- Language Dropdown (always visible on desktop) -->
    <div class="language-dropdown-wrapper">
      <button class="button-back language-button" (click)="toggleLanguageDropdown()" title="Change Language">
        <span class="language-flag">{{ currentLanguage === 'en' ? '🇺🇸' : '🇸🇦' }}</span>
        <span class="language-text">{{ getCurrentLanguageLabel() }}</span>
      </button>
      @if (isLanguageDropdownOpen) {
      <ul class="dropdown-menu language-menu" [ngClass]="{'dropdown-below': isLanguageDropdownOpen}">
        @for (option of languageOptions; track option.value) {
        <li (click)="selectLanguage(option.value)" [class.active]="currentLanguage === option.value">
          <span class="lang-flag">{{ option.flag }}</span>
          <span class="lang-label">{{ option.label }}</span>
        </li>
        }
      </ul>
      }
    </div>
    }

  </div>
</header>